let initialState = {
	id: "",
	shareLink: false,
	shareOption: "",
	accessCode: "",
	title: "",
	link: "",
};

export const slidesMetaData = (state = initialState, action) => {
	switch (action.type) {
		case "UPDATE_SLIDES_META_DATA":
			return {
				shareLink: Boolean(action.shareLink),
				shareOption: action.shareOption,
				accessCode: action.accessCode,
				link: action.link,
				title: action.title,
				id: action.id,
			};

		default:
			return state;
	}
};
